import React, { useState, useEffect, useContext } from "react";

import { NotificationsModalView } from "@wdpr/groot-components";
import config from "config.json";
import { Context } from "Context";
import useFetch from "hooks/useFetch";
import useLocalStorage from "hooks/useLocalStorage";
const oldMessagesProperty = "received-invitations";

const handleUndefined = (variable) => variable || "";

const NotificationsModalContent = (props) => {
	const [syndicatedDismissButton, setSyndicatedDismissButton] = useLocalStorage(
		"syndicatedDismissButton",
		false
	);
	const {
		headerData: {
			interstitial: { interstitialNotificationsModal },
		},
		profileData: { user },
		cdnUrl,
		cdnAssetsUrl,
	} = useContext(Context);
	const { messages, updateNotificationsAction, action } = props;
	const mainClass = "syndicated-notifications-modal";
	const [fetchTrigger, setFetchTrigger] = useState(0);
	const [optionParams, setOptionsParams] = useState(null);
	const [requestUrl, setRequestUrl] = useState("");
	const [invitationId, setInvitationId] = useState("");
	const { error } = useFetch(
		requestUrl ? requestUrl : "",
		optionParams,
		0,
		fetchTrigger
	);

	const handleNotificationAction = (links, operationType) => {
		if (!operationType || !user?.swid) {
			return null;
		}
		let invId;
		const hrefData = links?.[operationType]?.href;
		const options = links?.[operationType]?.post;
		const apiUrl = config.profile.apiUrl;
		const friendXId = handleUndefined(hrefData?.split("/")[3]);
		const headers = {
			...options.headers,
			swid: user.swid,
			token: user.authToken,
		};
		setOptionsParams({
			method: "PUT",
			headers,
			body: JSON.stringify(options.body),
		});
		switch (operationType) {
			case "accept":
				invId = options?.body["invitation-id"];
				setRequestUrl(`${apiUrl}/${friendXId}/${operationType}/${invId}`);
				updateNotificationsAction(links.self.href);
				setFetchTrigger((fetch) => fetch + 1);
				break;
			case "decline":
				invId = handleUndefined(hrefData?.split("/")[5]);
				setRequestUrl(`${apiUrl}/${friendXId}/${operationType}/${invId}`);
				updateNotificationsAction(links.self.href);
				setFetchTrigger((fetch) => fetch + 1);
				break;
			default:
				return null;
		}
		invId && setInvitationId(invId);
		return true;
	};
	const toggleElement = (elems) => {
		const elemsArray = elems.split(" ");
		elemsArray.forEach((item) => {
			const toggleElem = document?.querySelector(item);
			toggleElem.classList.toggle(`${mainClass}--hidden`);
		});
		if (elems.indexOf(".top") >= 0) {
			setSyndicatedDismissButton(true);
		}
	};
	useEffect(() => {
		if (
			error &&
			invitationId &&
			interstitialNotificationsModal?.familyFriendsErrorLink?.href
		) {
			window?.location.assign(
				`${interstitialNotificationsModal.familyFriendsErrorLink.href}${invitationId}/`
			);
		}
	}, [error, invitationId, interstitialNotificationsModal]);

	const isOldMessagesStructure = messages?.[0]?.[oldMessagesProperty];

	return <NotificationsModalView {...{
		mainClass,
		oldMessagesProperty,
		messages,
		syndicatedDismissButton,
		isOldMessagesStructure,
		handleNotificationAction,
		toggleElement,
		interstitialNotificationsModal,
		cdnUrl,
		cdnAssetsUrl,
		action,
	}} />
};

export default NotificationsModalContent;
